module.exports = __webpack_public_path__ + "img/1.8c20e89b.gif";